"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const lodash_1 = require("lodash");
exports.client = axios_1.default.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: { 'Content-Type': 'application/json' },
    timeout: 9500,
});
let internalJwt;
const patchAPIClientJWT = (jwt) => {
    internalJwt = jwt;
};
let internalWorkspaceId;
const patchAPIClientWorkspaceId = (workspaceId) => {
    internalWorkspaceId = workspaceId;
};
exports.client.interceptors.request.use((clientConfig) => {
    if (internalJwt) {
        clientConfig.headers.Authorization = `Bearer ${internalJwt}`;
    }
    if (internalWorkspaceId) {
        clientConfig.headers.wid = internalWorkspaceId;
    }
    return clientConfig;
});
exports.client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (401 === error.response.status) {
        patchAPIClientJWT(undefined);
    }
    return Promise.reject(error);
});
exports.extractErrorMessage = (error) => {
    const statusCode = lodash_1.get(error, 'response.data.statusCode');
    const errorMessage = lodash_1.get(error, 'response.data.message', error);
    return `Error ${statusCode}: ${errorMessage}`;
};
exports.setUpUser = async (jwt) => {
    // 1. Add JWT to all API requests
    await patchAPIClientJWT(jwt);
    // 2. Get user profile and workspace
    const [{ data: { workspaces } }, { data: { user } }] = await axios_1.default.all([
        exports.client.get('/workspaces'),
        exports.client.get('/users/me'),
    ]);
    // 3. Set active workspace
    const activeWorkspaceId = lodash_1.get(user, 'defaultWorkspaceId', workspaces.length > 0 ? workspaces[0].id : null);
    // 4. Patch API for active workspace
    if (activeWorkspaceId) {
        await patchAPIClientWorkspaceId(activeWorkspaceId);
    }
    // 5. Dispatch new state
    return { activeWorkspaceId, workspaces, me: user };
};
exports.setUpWorkspace = async (workspaceId) => {
    await patchAPIClientWorkspaceId(workspaceId);
};
//# sourceMappingURL=api.js.map